type DemoVisitorStorage = Pick<Storage, 'getItem' | 'setItem'>;

/**
 * Identidad del visitante en el chat de demo.
 * Sin `freshSessionKey` se reutiliza la sesión guardada (recarga de la misma URL).
 * Con una clave nueva se empieza una conversación distinta; la misma clave conserva el hilo.
 */
export function resolveDemoVisitorId(
  storage: DemoVisitorStorage,
  token: string,
  freshSessionKey: string | null | undefined,
  createId: () => string,
): string {
  const storageKey = `demo_visitor_${token}`;
  if (freshSessionKey) {
    const boundKey = `demo_fresh_${token}`;
    const previousFresh = storage.getItem(boundKey);
    const existing = storage.getItem(storageKey);
    if (previousFresh === freshSessionKey && existing) return existing;
    const newId = createId();
    storage.setItem(storageKey, newId);
    storage.setItem(boundKey, freshSessionKey);
    return newId;
  }
  const existing = storage.getItem(storageKey);
  if (existing) return existing;
  const newId = createId();
  storage.setItem(storageKey, newId);
  return newId;
}
